import React, { useContext } from 'react';
import { AppCtx } from '../../../AppCtx';
import './TopFloatMenuComponent.css';

const menuStyle = {
  position:'fixed', zIndex:11, top:0, right:0, width:'36px', height:'36px',
  padding:0, boxSizing:'border-box', borderRadius:'6px', fontSize:'1.3em', gap:'0px',
  color:'var(--float-menu-font-color)',
  backgroundColor:'var(--float-menu-bg-color)',
  display:'flex', alignItems:'center', justifyContent:'center'
};

const TopRightMenuComponent = ({children}) => {
  const { showQuickMenu, isFullScreen } = useContext(AppCtx);
  return (showQuickMenu || !isFullScreen) && ( <div className="top-bar-edge top-bar-right" style={menuStyle}>{children}</div> );
};

export default TopRightMenuComponent;
